import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      searchTitle: '',
      disabelConfirm: false,
      followUpTableInformationHeader: [
        {
          text: '',
          value: 'icon',
          align: 'center',
          width: '30px',
          sortable: false,
        },
        { text: 'شهر', value: 'city', align: 'center', width: '150px' },
        { text: 'آدرس', value: 'address', align: 'center', width: '300px' },
        {
          text: 'کد آمبولانس',
          value: 'ambulanceCode',
          align: 'center',
          width: '120px',
        },
        {
          text: 'تلفن اصلی / پیگیری',
          value: 'phoneNumber',
          align: 'center',
          width: '170px',
        },
        { text: 'شکایت اصلی', value: 'cc', align: 'center', width: '150px' },
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          width: '120px',
        },
        {
          text: 'وضعیت آمبولانس',
          value: 'ambulanceStatus',
          align: 'center',
          width: '150px',
        },
        {
          text: 'وضعیت ماموریت',
          value: 'status',
          align: 'center',
          width: '150px',
        },
        { text: 'کارشناس', value: 'user', align: 'center', width: '150px' },
      ],
      followUpMissions: [],
    };
  },
  methods: {
    goToMissionPage: function (_, data) {
      let id = data.item.id.toString();
      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr5r2Dfr7lyf8N').toString();
      this.$router.push({ name: 'followUpMission', params: { id: encryptId } });
    },
  },
};
